import React, { useState } from 'react';

import { ACTION_CREATE } from 'constants/permission.constants';
import { AddIcon } from 'constants/icon.constants';
import { DataTableAction } from 'components/DataTable';
import { ENTITY_USER_ROLE } from 'constants/schemas';
import NewUserRoleDialog from './NewUserRoleDialog';
import { formatType } from 'utils/entity.utils';
import { useMyGlobalPermission } from 'hooks/store.hooks';

function ActionAddUserRole() {
  const [newUserRoleDialogOpen, setNewUserRoleDialogOpen] = useState(false);
  const canCreateUserRole = useMyGlobalPermission(ENTITY_USER_ROLE, ACTION_CREATE);
  return !canCreateUserRole ? null : (
    <DataTableAction
      label={`Add ${formatType(ENTITY_USER_ROLE)}`}
      icon={<AddIcon />}
      onClick={() => setNewUserRoleDialogOpen(true)}
    >
      <NewUserRoleDialog
        open={newUserRoleDialogOpen}
        onClose={() => setNewUserRoleDialogOpen(false)}
      />
    </DataTableAction>
  );
}

export default ActionAddUserRole;
